import React from 'react';
import { MicIcon, ListChecksIcon, AlertTriangleIcon, UsersIcon, CloudSunIcon, ShieldCheckIcon } from 'lucide-react';
import { ScreenProps } from '../../types/ptp';
import { PrimaryButton } from '../ui/PrimaryButton';
import { useI18n } from '../../config/i18n';
export function NewPTPScreen({
  data,
  onNext
}: ScreenProps) {
  const {
    t
  } = useI18n();
  return <div className="flex flex-col min-h-full justify-between pb-4 pt-3 overflow-y-auto" data-id="element-556">
      <div className="flex flex-col items-center text-center space-y-4" data-id="element-557">
        <div className="mb-1 flex flex-col items-center" data-id="element-558">
          <div className="mb-1 w-12 h-12 rounded-xl bg-gray-900 flex items-center justify-center" data-id="element-559">
            <ShieldCheckIcon className="w-7 h-7 text-[#FFC107]" data-id="element-560" />
          </div>
          <div className="text-[10px] text-gray-400 uppercase tracking-[0.15em] font-medium" data-id="element-561">
            {t('newPtp.poweredBy')}
          </div>
        </div>

        <div data-id="element-562">
          <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-563">
            {t('newPtp.title')}
          </h1>
          <p className="text-gray-500 text-base max-w-[300px] mx-auto leading-relaxed" data-id="element-564">
            {t('newPtp.subtitle')}
          </p>
        </div>

        <div className="w-full mt-4 bg-gray-50 border border-gray-200 rounded-xl p-5 text-left" data-id="element-565">
          <p className="text-xs text-gray-400 uppercase tracking-wider font-semibold mb-3" data-id="element-566">
            {t('newPtp.whatToExpect')}
          </p>
          <div className="space-y-3" data-id="element-567">
            {[{
            icon: MicIcon,
            text: t('newPtp.step1')
          }, {
            icon: ListChecksIcon,
            text: t('newPtp.step2')
          }, {
            icon: CloudSunIcon,
            text: t('newPtp.step3')
          }, {
            icon: UsersIcon,
            text: t('newPtp.step4')
          }, {
            icon: AlertTriangleIcon,
            text: t('newPtp.step5')
          }, {
            icon: ShieldCheckIcon,
            text: t('newPtp.step6')
          }].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-568">
                <div className="w-8 h-8 rounded-lg bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-569">
                  <item.icon className="w-4 h-4 text-yellow-500" data-id="element-570" />
                </div>
                <span className="text-gray-700 text-sm" data-id="element-571">{item.text}</span>
              </div>)}
          </div>
        </div>
      </div>

      <div className="mt-6" data-id="element-572">
        <PrimaryButton onClick={onNext} data-id="element-573">{t('newPtp.startPlan')}</PrimaryButton>
      </div>
    </div>;
}